import { render, staticRenderFns } from "./AreaNode.vue?vue&type=template&id=8090e48c&scoped=true"
import script from "./AreaNode.vue?vue&type=script&lang=js"
export * from "./AreaNode.vue?vue&type=script&lang=js"
import style0 from "./AreaNode.vue?vue&type=style&index=0&id=8090e48c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8090e48c",
  null
  
)

export default component.exports